import { FormControl, IconButton, MenuItem } from '@material-ui/core'
import { Plus, Trash2 } from 'lucide-react'
import { useEffect, useState } from 'react'
import useQueues from '../../hooks/useQueues'
import { InputField } from '../InputField'
import SelectInput from '../SelectInput'
import { useStyles } from './styles'

function QueueOptionItem({ option, index, queues, onUpdate, onDelete }) {
  const classes = useStyles()

  const handleTitleChange = event => {
    onUpdate(index, { ...option, title: event.target.value })
  }

  const handleForwardQueueChange = event => {
    onUpdate(index, { ...option, forwardQueueId: event.target.value })
  }

  const handleDelete = () => {
    onDelete(index, option)
  }

  return (
    <div className={classes.step}>
      <div className={classes.stepIndicator}>{index + 1}</div>
      <div className={classes.inputGroup}>
        <InputField
          value={option.title}
          onChange={handleTitleChange}
          placeholder="Título da opção"
          id={option.title || `option-title-${index}`}
          name={option.title || `option-title-${index}`}
          style={{ flex: 1 }}
          emoji
        />

        {/* <FormControl size="small" style={{ minWidth: 400, flexShrink: 0 }}>
          <SelectInput
            value={option.forwardQueueId || ''}
            onChange={handleForwardQueueChange}
            id={`option-title-${index}`}
            name={`option-title-${index}`}
          >
            <MenuItem value="">Selecione</MenuItem>
            {queues
              .filter(queue => !queue.isBot && String(queue.nivel) === '1')
              .map(queue => (
                <MenuItem key={queue.id} value={queue.id}>
                  {queue.name} (Nível: {queue.nivel || 'N/A'})
                </MenuItem>
              ))}
          </SelectInput>
        </FormControl> */}
        <IconButton
          size="small"
          onClick={handleDelete}
          className={classes.iconButtonDelete}
        >
          <Trash2 size={18} />
        </IconButton>
      </div>
    </div>
  )
}

// Componente principal QueueOptions
export function QueueOptions({
  queueId,
  options,
  onAddOption,
  onUpdateOption,
  onDeleteOption
}) {
  const classes = useStyles()
  const [queues, setQueues] = useState([])
  const { findAll: findAllQueues } = useQueues()

  useEffect(() => {
    const loadQueues = async () => {
      const list = await findAllQueues()
      setQueues(list)
    }
    loadQueues()
  }, [findAllQueues])

  return (
    <div className={classes.root}>
      <div className={classes.titleMenu}>
        <span>Menu de Atendimento</span>
      </div>

      <div className={classes.stepperContainer}>
        {options.map((option, index) => (
          <QueueOptionItem
            key={option.id || `new-${index}`}
            option={option}
            index={index}
            queues={queues}
            onUpdate={onUpdateOption}
            onDelete={onDeleteOption}
          />
        ))}

        <div className={classes.addButton} onClick={onAddOption}>
          <div className={classes.plusIcon}>
            <Plus size={16} />
          </div>
          <span>Adicionar mais</span>
        </div>
      </div>
    </div>
  )
}
